export default __webpack_public_path__ + "static/media/ccf6d17ae9e5b922e9d9c90c15336387.svg";